import axios from '../../axios.js'

export default {
  fetchRecords({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/tenant-pdf-templates', {
          params: payload,
        })
        .then(response => {
          commit('SET_TENANT_PDF_TEMPLATES', response.data)
          commit('SET_PAGINATION', {
            currentPage: response.headers['x-pagination-page'],
            totalPage: response.headers['x-pagination-page-count'],
            pageTotal: response.headers['x-pagination-count'],
            totalItem: response.headers['x-pagination-total'],
          })

          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchRecord(context, templateId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/tenant-pdf-templates/${templateId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addRecords(items) {
    return new Promise((resolve, reject) => {
      axios
        .post('/tenant-pdf-templates/bulk', { bulk: items })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addRecord({ commit }, item) {
    console.log(item);
    console.log(item);
    return new Promise((resolve, reject) => {
      axios
        .post('/tenant-pdf-templates', item)
        .then(response => {
          commit('ADD_TENANT_PDF_TEMPLATE', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateRecord({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put('/tenant-pdf-templates/' + item.id, item)
        .then(response => {
          commit('UPDATE_TENANT_PDF_TEMPLATE', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },
  removeRecord({ commit }, templateId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/tenant-pdf-templates/${templateId}`)
        .then(response => {
          commit('DELETE_TENANT_PDF_TEMPLATE', templateId)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  previewPdfTemplate({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/tenant-pdf-templates/preview", item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
